export class EditCustomerEmployeeContactInput {
    public id: number = 0;
    public contact: string = '';
    public isDefault: boolean = false;
    public contactTypeId: number = 0;
}
